export const SELECTED_ALPHA_JSON_KEY = "selectedAlpha";
export const NOT_SELECTED_ALPHA_JSON_KEY = "notSelectedAlpha";
export const OBJECT_ALPHA_JSON_KEY = "objectAlpha";
export const HIDDEN_OPACITY_3D_JSON_KEY = "hiddenObjectAlpha";
export const SKELETON_CROSS_SECTION_RENDER_SCALE_JSON_KEY =
  "skeletonCrossSectionRenderScale";
export const SKELETON_PERSPECTIVE_RENDER_SCALE_JSON_KEY =
  "skeletonPerspectiveRenderScale";
export const SPATIAL_SKELETON_GRID_BIAS_2D_JSON_KEY =
  "spatialSkeletonGridBiasCrossSection";
export const SPATIAL_SKELETON_GRID_BIAS_3D_JSON_KEY =
  "spatialSkeletonGridBiasPerspective";
export const SATURATION_JSON_KEY = "saturation";
export const HOVER_HIGHLIGHT_JSON_KEY = "hoverHighlight";
export const HIDE_SEGMENT_ZERO_JSON_KEY = "hideSegmentZero";
export const BASE_SEGMENT_COLORING_JSON_KEY = "baseSegmentColoring";
export const IGNORE_NULL_VISIBLE_SET_JSON_KEY = "ignoreNullVisibleSet";
export const MESH_JSON_KEY = "mesh";
export const SKELETONS_JSON_KEY = "skeletons";
export const SEGMENTS_JSON_KEY = "segments";
export const EQUIVALENCES_JSON_KEY = "equivalences";
export const COLOR_SEED_JSON_KEY = "colorSeed";
export const SEGMENT_STATED_COLORS_JSON_KEY = "segmentColors";
export const MESH_RENDER_SCALE_JSON_KEY = "meshRenderScale";
export const CROSS_SECTION_RENDER_SCALE_JSON_KEY = "crossSectionRenderScale";
export const SKELETON_RENDERING_JSON_KEY = "skeletonRendering";
export const SKELETON_SHADER_JSON_KEY = "skeletonShader";
export const SKELETON_CODE_VISIBLE_KEY = "codeVisible";
export const SEGMENT_QUERY_JSON_KEY = "segmentQuery";
export const SPATIAL_SKELETON_NODE_QUERY_JSON_KEY = "spatialSkeletonNodeQuery";
export const SPATIAL_SKELETON_NODE_FILTER_JSON_KEY =
  "spatialSkeletonNodeFilter";
export const ROI_FILTER_JSON_KEY = "roiFilter";
// Name of the linked parcellation layer whose labels dissect the tracts (the
// Filter tab's "By segmentation label" panel). Value is the layer name.
export const ROI_LABEL_LAYER_JSON_KEY = "roiLabelLayer";
// Tool identifier for the global "non-passing opacity" Render-tab control; the
// value itself persists inside ROI_FILTER_JSON_KEY (RoiFilterState.ghostAlpha).
export const ROI_NONPASSING_ALPHA_JSON_KEY = "roiNonPassingOpacity";
export const IGNORE_SKELETON_MEMORY_CEILING_JSON_KEY =
  "ignoreSkeletonMemoryCeiling";
export const SPATIAL_SKELETON_DETAIL_FOCUS_JSON_KEY =
  "spatialSkeletonDetailFocus";
export const MESH_SILHOUETTE_RENDERING_JSON_KEY = "meshSilhouetteRendering";
export const LINKED_SEGMENTATION_GROUP_JSON_KEY = "linkedSegmentationGroup";
export const LINKED_SEGMENTATION_COLOR_GROUP_JSON_KEY =
  "linkedSegmentationColorGroup";
export const SEGMENT_DEFAULT_COLOR_JSON_KEY = "segmentDefaultColor";
export const ANCHOR_SEGMENT_JSON_KEY = "anchorSegment";
export const SKELETON_RENDERING_SHADER_CONTROL_TOOL_ID =
  "skeletonShaderControl";
